import React, {useState} from 'react';
import {connect} from 'react-redux';
import {updateUser, deleteUser} from './actions/userAction';

const UserCard = ({user: {id, name, email, password }, updateUser, deleteUser}) => {
    const [user, setUser] = useState({name: name, email: email, password: password})

    const changeHandler = e => {
        e.persist();
        setUser({...user, [e.target.name]: e.target.value})
    }
    const handleSubmit = e => {
        e.preventDefault();
        updateUser(id, user)
    }

    const handleDelete = e => {
        e.preventDefault();
        deleteUser(id);
    }

    return (
        <div>
            <div>
                <form onSubmit={handleSubmit}>
                    <label>User: {id}
                    <input 
                        id='name'
                        type='text'
                        name='name'
                        placeholder='Change your name'
                        onChange={changeHandler}
                        value={user.name}
                    />
                    </label>
                    <label>Email: {id} 
                    <input
                        id='email'
                        type='email'
                        name='email'
                        placeholder='Change your email'
                        onChange={changeHandler}
                        value={user.email}
                    />
                    </label>
                    <label>Password: {id}
                    <input
                        id='password'
                        type='password'
                        name='password'
                        placeholder='Change your password'
                        onChange={changeHandler}
                        value={user.email}
                    />
                    </label>
                </form>
                <button onCLick={handleDelete}>Delete</button>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {

    }
}

export default connect(mapStateToProps, {updateUser, deleteUser})(UserCard)